import styled from 'styled-components'
import { transparentize } from 'polished'

import {
  COLORS,
  CSS_PSEUDO_CLASSES_RESET,
  dropShadow,
  focus,
  focusSelector,
  media,
  TEMPLATE_PSEUDO_CLASSES,
} from '../../styles'
import Icon from '../Icon'

const Styled = styled.div`
  width: 100%;
  height: 100%;
`
Styled.container = styled.div`
  width: 100%;
  padding-top: 100%;
  background-color: ${COLORS.cream};
  position: relative;
  ${media.medium`
    height: 100%;
    padding-top: 0;
  `}
`
Styled.patternBakground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 65%;
  z-index: 1;
  background-color: ${({ backgroundColor }) => backgroundColor || 'none'};
  ${media.medium`
    height: calc(100% - 27rem);
  `}
`
Styled.patternContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
Styled.recipeImageContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
`
Styled.recipeImage = styled.div`
  height: 100%;
  position: relative;
  width: auto;
  display: block;
  margin: 0 auto;

  img {
    background-repeat: no-repeat;
    ${({ imageLoaded }) =>
      dropShadow(
        {
          offsetX: '0.4rem',
          offsetY: '0.8rem',
          color: transparentize(0.4, COLORS.black),
        },
        imageLoaded,
      )}
  }
  ${({ imageLoaded }) => media.small`
    img {
      ${dropShadow(
        {
          offsetX: '0.6rem',
          offsetY: '1.2rem',
          color: transparentize(0.4, COLORS.black),
        },
        imageLoaded,
      )}
    }
  `}
  ${({ imageLoaded }) => media.medium`
    img {
      ${dropShadow(
        {
          offsetX: '0.8rem',
          offsetY: '1.6rem',
          color: transparentize(0.4, COLORS.black),
        },
        imageLoaded,
      )}
    }
  `}
  ${({ imageLoaded }) => media.xLarge`
    img {
      ${dropShadow(
        {
          offsetX: '1rem',
          offsetY: '2rem',
          color: transparentize(0.4, COLORS.black),
        },
        imageLoaded,
      )}
    }
  `}
  ${({ imageLoaded }) => media.xxLarge`
    img {
      ${dropShadow(
        {
          offsetX: '1.6rem',
          offsetY: '3.2rem',
          color: transparentize(0.4, COLORS.black),
        },
        imageLoaded,
      )}
    }
  `}
  ${({ imageLoaded }) => media.xxxLarge`
    img {
      ${dropShadow(
        {
          offsetX: '2.8rem',
          offsetY: '5.6rem',
          color: transparentize(0.4, COLORS.black),
        },
        imageLoaded,
      )}
    }
  `}
`
Styled.videoPlayButtonIcon = styled(Icon)`
  width: 3.6rem;
  height: 3.6rem;
`
Styled.videoPlayButton = styled.div`
  margin: 0 auto;
  display: block;
  border: 0;
  border-radius: 9999px;
  height: 7.2rem;
  width: 7.2rem;
  padding: 1.8rem;
  background-color: ${COLORS.primary};
  transition:
    opacity 0.2s ease-in-out,
    background-color 0.2s ease-in-out;
  -webkit-tap-highlight-color: ${COLORS.transparent};
  ${focus`
    outline-color: ${COLORS.white};
  `}
`
Styled.videoPlay = styled.div`
  flex: 1;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 3;
  position: absolute;
  inset: 0;
  ${focus`
    ${CSS_PSEUDO_CLASSES_RESET.focus};
  `}
  ${focusSelector(Styled.videoPlayButton)`
    ${TEMPLATE_PSEUDO_CLASSES.focus};
    outline-color: ${COLORS.white};
    opacity: 1;
  `}
`

export default Styled
